angular.module("digitalLeasing.module").component("taxCreditFacility", {
    templateUrl: "ng/components/digitalLeasing/financialLeasingRequest/taxCreditFacility/taxCreditFacility.view.html",
    bindings: {
        model: "=", //preventivo
        taxIsOk: "&",
        taxIsNotOk: "&"
    },
    controllerAs: "taxCreditFacilityCtrl",
    controller: function TaxCreditFacilityController() {
        var self = this;

        self.$onInit = function () {

            self.supportModel = {
                domanda1Splitted: [],
                domanda2Splitted: [],
                domanda3Splitted: [],
                showLabel: false
            }
            self.model.questionarioAgv.domande.forEach(function (domanda) {
                if (domanda.risposte[0] && domanda.risposte[0].selected) {
                    self.supportModel.showLabel = true;
                    domanda.risposte[1].selected = false;
                }
                if (domanda.risposte[1] && domanda.risposte[1].selected) {
                    domanda.risposte[0].selected = false;
                    self.supportModel.showLabel = true;
                }
                if (domanda.risposte[2] && domanda.risposte[2].selected) {
                    self.supportModel.showLabel = true;
                }

                if (domanda.domanda === "LBL_CI1") {
                    self.supportModel.domanda1Splitted[0] = "LBL_CI1_0";
                    self.supportModel.domanda1Splitted[1] = "LBL_CI1_1";
                    self.supportModel.domanda1Splitted[2] = "LBL_CI1_2";
                    self.supportModel.domanda1Splitted[3] = "LBL_CI1_3";
                }

                if (domanda.domanda === "LBL_CI2") {
                    self.supportModel.domanda2Splitted[0] = "LBL_CI2_0";
                    self.supportModel.domanda2Splitted[1] = "LBL_CI2_1";
                    self.supportModel.domanda2Splitted[2] = "LBL_CI2_2";
                }

                if (domanda.domanda === "LBL_CI4") {
                    self.supportModel.domanda3Splitted[0] = "LBL_CI4_0";
                    self.supportModel.domanda3Splitted[1] = "LBL_CI4_1";
                    self.supportModel.domanda3Splitted[2] = "LBL_CI4_2";
                    self.supportModel.domanda3Splitted[3] = "LBL_CI4_3";
                }
            });

            checkValidation();
        };

        self.handleChange = function (risposta, selected) {

            self.model.questionarioAgv.domande
                .filter(domanda => domanda.risposte
                    .map(rispostaModel => rispostaModel.risposta)
                    .some(rispostaModelLabel => rispostaModelLabel === risposta))
                .forEach(domanda => {
                    if (selected) {
                        domanda.risposte[0].selected = true;
                        domanda.risposte[1].selected = false;
                        checkUnique(domanda)
                    } else {
                        domanda.risposte[0].selected = false;
                        domanda.risposte[1].selected = true;
                    }
                });
                
            self.supportModel.showLabel = self.model.questionarioAgv.domande.filter(domanda => !!domanda.risposte[0].selected).length > 0
            checkValidation();
        }

        var checkUnique = function(domanda){
             self.model.questionarioAgv.domande.forEach(function(x) {
                if(domanda.cdDomanda != x.cdDomanda && !domanda.unique && !x.unique) {
                    self.handleChange(x.risposte[0].risposta)
                }
            })
        }

        var checkValidation = function () {

            var test = self.model.questionarioAgv.domande.every(function (domande) {
                return domande.risposte.every(function (risposta) {
                    return risposta.selected != null;
                })

            })
            if (test) {
                self.taxIsOk();
            } else {
                self.taxIsNotOk();
            }
        }
    }
});